<template>
    <rkm-modal
        large
        ref="Modal"
        title="Cadastro de prioridade"
    >
        <Form
            :data="data"
            :originalPrioridade="originalPrioridade"
            :prioridade="prioridade"
            @save="close"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.Form.save()"
                color="primary"
            >
                {{ prioridade ? 'Salvar' : 'Incluir' }}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>

// Components.
import Form from './Form'

// Mixins.
import { object } from '@/mixins'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        originalPrioridade: null,
        prioridade: null,
    }),
    methods: {
        open(prioridade = null) {

            this.resetForm()

            this.originalPrioridade = prioridade
            this.prioridade = this.clone(prioridade)

            this.$refs.Modal.show()
        },
        close() {

            this.$refs.Modal.hide()
        },
        resetForm() {

            this.data.form.prioridade = []
        },
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
    }
}
</script>